module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/css-modules-by-example.json
// module id = 797
// module chunks = 63184286758026